module.exports = __webpack_public_path__ + "img/amazon.7fd24b82.png";